<template>
  <div class="logo">
    <div class="container">
      <div class="row m0 jf-evently">
        <div v-for="category of visibleCategories" :key="category.id" class="col-xs-3 center-xs logo__line">
          <router-link
            class="nav-link no-underline logo__link"
            :to="categoryLink(category)"
          >
            <i class="logo__icon" :class="'icon-' + category.logo" />
            <span class="logo__text">{{ category.name }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from 'config'
import { mapGetters } from 'vuex'
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import groupBy from 'lodash-es/groupBy'
import { getThumbnailCategoryPath as _thumbnailHelper } from '@vue-storefront/core/helpers'

export default {
  data () {
    return {
      // filter only: tiles keep the category position order from Magento
      idToShow: [3, 1172, 834],
      categoriesLogo: {
        3: 'Prasa',
        1172: 'prenumerata-kolekcji',
        834: 'dla-dzieci'
      }
    }
  },
  computed: {
    ...mapGetters('category-next', ['getMenuCategories']),
    categoriesMap () {
      return groupBy(this.getMenuCategories, 'parent_id')
    },
    visibleCategories () {
      let categoriesToShow = []
      for (let category of this.categoriesMap[config.server.mainCategoryId]) {
        if (this.idToShow.includes(category.id)) {
          category.logo = this.categoriesLogo[category.id]
          categoriesToShow.push(category)
        }
      }
      return categoriesToShow
    }
  },
  methods: {
    thumbnail (src) {
      return this.getThumbnail(src, 900, 900, 'category')
    },
    categoryLink (category) {
      return formatCategoryLink(category)
    }
  }
}
</script>

<style lang="scss" scoped>
.jf-evently {
  justify-content: space-evenly;
}
.logo {
  min-height: 55px;
  &__line {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 8px;
  }
  &__link {
    color: black;
    text-align: center;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    -ms-flex-direction: column;
  }
  &__text {
    margin-top: 5px;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    // white-space: nowrap;
  }
  &__icon {
    font-size: 28px;
    height: 28px;
  }
}
</style>
